/**
 * @param {object} item - Item
 * @param {object[]} columns - Column data
 * @param {number[]} number - qualifierRow
 * @param qualiferRow
 * @param conferenceLabel
 * @param premWinner
 * @param competitionId
 * @param compSeasonId
 * @param roundId
 * @param roundNumber
 * @returns {object[]} qualifierRow - row data
 */
export const composeRowData = (
    item,
    columns,
    qualiferRow,
    conferenceLabel,
    premWinner,
    competitionId,
    compSeasonId,
    roundNumber
) => {
    let rowData = {};
    columns.forEach((column) => {
        const accessor = column.accessor;
        rowData[accessor] = item[accessor];
    });

    rowData.clubName = item.club;
    rowData.qualiferRow = qualiferRow;
    rowData.isConference = conferenceLabel ? true : false;
    rowData.premWinner = premWinner || false;
    rowData.competitionId = competitionId;
    rowData.compSeasonId = compSeasonId;
    rowData.roundNumber = roundNumber;
    rowData.isActiveClub =
        window?.CLUB_ID === rowData?.club?.club?.id?.toString();
    rowData.byeUpNext = item?.byeUpNext || false;

    return rowData;
};
